// removed by extract-text-webpack-plugin
module.exports = {"markdown":"_3pB2-1flAgpGvffFqFld4b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/markdown.module.css
// module id = 825
// module chunks = 0